<template>
    <div class="pull-right video-entry-status">
        <h6>Nominee Entry Status</h6>
        <Select2 v-model="nomineeEntryStatus" :options="entryStatuses" :settings="{placeholder: 'Select Video'}" @change="myChangeEvent($event)"></Select2>
    </div>
</template>


<script>
    import Select2 from 'v-select2-component';
    import axios from 'axios';
    export default {
        props: ['status', 'entryid'],
        components: {Select2},
        data() {
            return {
                entryStatuses: ['Incomplete', 'Submitted', 'Need More Information', 'Ready To Go Live', 'Live', 'Canceled'],
                nomineeEntryStatus: this.status
            }
        },
        created: function() {
            if(!this.nomineeEntryStatus) {
                this.nomineeEntryStatus = 'Incomplete';
            }
        },
        methods: {
            myChangeEvent(val){
                // TODO --- Confirm it's saving properly with proper auth check, I believe it is
                let app = this;
                let actionUrl = '/entry/' + app.entryid;
                axios(
                    {
                        method: 'PUT',
                        url: actionUrl,
                        data: {
                            nominee_video_status: app.nomineeEntryStatus,
                            token: false
                        }
                    }).then(function(response) {
                        // Todo - remove console.log below
                        // console.log(response, 'this is the response')
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
        }
    }
</script>
